import { Button, Card, Col, Row, Tooltip } from "antd";
import './card.css';
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import '../../components/DocComponents/card.css'

export default function DocListItem({ doc }) {
    // const { onLogout, authState } = useAuth();

    const url =  doc.file_url +  '?response-content-disposition=' + encodeURIComponent(`attachment; filename="${doc.name}.${doc.file_url.split('.').pop()}`);

    return (
        <Card
            style={{
                boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
            }}
            actions={[
                <Link to={`/doc/${doc.uuid}`}>
                    <Tooltip title="ნახვა" mouseEnterDelay={0.5}                    >
                        <Button type="text" icon={<i className="fa-solid fa-eye" style={{ color: '#13c2c2', fontSize: 18 }}></i>} />
                    </Tooltip>
                </Link>,
                <Tooltip title='ჩამოტვირთვა' mouseEnterDelay={0.5}>
                    <Button type="text" onClick={() => {
                        window.open('docview/' + url, '_blank');
                    }} icon={<i className="fa-solid fa-download" style={{ color: '#4096ff', fontSize: 18 }}></i>} />
                </Tooltip>,
                <Tooltip title={doc.is_active ? 'აქტიური' : 'გაუქმებული'} color={doc.is_active ? 'green' : 'red'}>

                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 10 }}>
                        {
                            doc.is_active ?
                                <i className="fa-solid fa-circle-check" style={{ color: 'green', fontSize: 25 }}></i>
                                :
                                <i className="fa-solid fa-circle-xmark" style={{ color: 'red', fontSize: 25 }}></i>
                        }
                    </div>
                </Tooltip>
            ]}
            cover={
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Row justify='space-between' style={{ margin: 10, padding: 10, height: 200, WebkitBorderRadius: 15, boxShadow: 'rgba(0, 0, 0, 0.15) 0px 2px 8px', width: '100%', }}>
                        <Col span={24} style={{ height: 90 }}>
                            <div title={doc?.name} className="title-3" style={{ textAlign: 'center', fontWeight: '600' }}>{doc?.name}</div>
                        </Col>
                        <Col span={24} style={{ height: 20 }}>
                            <hr style={{border: '1px solid lightgray', width: '100%'}}/>
                        </Col>
                        <Col span={24} style={{ height: '100%' }}>
                            <div title={doc?.comment} className="description" style={{fontSize: 12, fontWeight:'400'}}>
                                {doc?.comment}
                            </div>

                        </Col>
                    </Row>
                </div>
            }
        >
            <Card.Meta
                title={
                    <Row justify='space-between' style={{paddingLeft: 20,paddingRight: 20}}>
                        <Col span={12}>
                            {doc.department + '-' + doc.hierarchy + '-' + doc.number+(doc?.number_suffix ? doc?.number_suffix : '')}
                        </Col>
                        <Col span={12} style={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 10}}>
                            {doc?.file_url?.split('.')?.pop()?.trim() === 'xlsx' ? <i className="fa-solid fa-file-excel" style={{ color: 'green', fontSize: 18 }}></i> : (doc?.file_url?.split('.')?.pop()?.trim() === 'docx'||doc?.file_url?.split('.')?.pop()?.trim() === 'doc') ? <i className="fa-solid fa-file-word" style={{ color: 'blue', fontSize: 18 }}></i> : <i className="fa-solid fa-file-pdf" style={{ color: 'red', fontSize: 18 }}></i>}
                        </Col>
                    </Row>  
                }
                description={
                    <Row>
                        <Col span={24}>
                            <hr style={{border: '1px solid lightgray', width: '100%'}}/>
                        </Col>
                        <Col span={12}>
                            გამოიცა
                        </Col>
                        <Col span={12}>
                            აიტვირთა
                        </Col>
                        <Col span={12}>
                            {dayjs(doc.issue_date).format('DD.MM.YYYY')}
                        </Col>
                        <Col span={12}>
                            {dayjs(doc.upload_date).format('DD.MM.YYYY')}
                        </Col>
                    </Row>
                }
            />
        </Card>
    )
}